import * as React from 'react';
import { ICancellationPageProps } from '../CancellationPage/CancellationPage.interfaces';
import { ISalePageProps } from '../SalePage/SalePage';
import { ITravelBirdSalePageProps } from '../TravelBirdSalePage/TravelBirdSalePage.interfaces';
import ApplicationContainer from './Application.container';
import { IApplicationContainerProps } from './Application.interfaces';
import ApplicationRouter from './Application.router';

/**
 * Main Application component to be consumed by Flashsales
 */
export const Application: React.FunctionComponent<IApplicationContainerProps &
  (ISalePageProps | ITravelBirdSalePageProps | ICancellationPageProps)> = props => {
  return (
    <ApplicationContainer
      territory={props.territory}
      isWhiteLabel={props.isWhiteLabel}
      userTerritory={props.userTerritory}
      affiliate={props.affiliate}
      currency={props.currency}
      apiUrl={props.apiUrl}
      theme={props.theme}
      translationObject={props.translationObject}
      isOpenSite={props.isOpenSite}
      userId={props.userId}
      defaultViewport={props.defaultViewport}
      history={props.history}
      featureFlags={props.featureFlags}
      apiUrlTravelBird={props.apiUrlTravelBird}
      refreshTokenUrl={props.refreshTokenUrl}
      isRebookingEnabled={props.isRebookingEnabled}
    >
      <ApplicationRouter
        travelBirdOfferId={(props as ITravelBirdSalePageProps).travelBirdOfferId}
        saleId={(props as ISalePageProps).saleId}
        isPreview={(props as ISalePageProps).isPreview}
        loginUserFunction={(props as ISalePageProps).loginUserFunction}
        bookingId={(props as ICancellationPageProps).bookingId}
      />
    </ApplicationContainer>
  );
};

Application.displayName = 'Application';

export default Application;
